import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';
import { combineLatest, debounceTime, filter, map, take } from 'rxjs';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { withLatestFrom } from 'rxjs/operators';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { appSelectors } from '@store/selectors/app.selectors';

export const userIsGGCCGuard: CanMatchFn = () => {
  const router = inject(Router);
  const store = inject(Store<StoreState>);
  const floatingAlertService = inject(FloatingAlertsService);
  const check$ = combineLatest([store.select(appSelectors.generalLoading), store.select(userSelectors.webIsReady)]).pipe(
    debounceTime(100),
    filter(([isLoading, webIsReady]) => !isLoading && webIsReady)
  );
  return check$.pipe(
    withLatestFrom(store.select(userSelectors.authUser), store.select(userSelectors.authUserError), store.select(userSelectors.country)),
    filter(([, user, userError]) => user != null || userError != null),
    take(1),
    map(([, user, , country]) => ({ type: user?.type, country })),
    map(({ type, country }) => {
      if (type === 'GGCC' || country === 'PT') {
        return true;
      }
      floatingAlertService.error('ROUTES.ACCESS_NOT_ALLOWED');
      return router.createUrlTree(AcRoutingService.HOME_ROUTE());
    })
  );
};
